var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 423,
    viewBox: "0 0 373 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.604 42.7835C84.2043 45.4714 78.8284 39.1995 78.8284 70.5591C76.5357 44.5755 75.2444 44.5755 51.0527 42.7835C72.5565 40.9915 76.2566 38.1542 78.8284 15.0078C78.8284 42.7835 84.2043 40.0955 106.604 42.7835Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2132 65.8003C51.9928 91.3487 42.1359 93.4358 75.7033 111.772C46.5497 99.0333 45.7947 100.415 29.7311 125.263C40.3867 101.197 39.5132 95.5774 16.241 79.2904C45.9721 95.5314 46.2384 88.2053 62.2132 65.8003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M317.77 382.921C285.456 386.799 277.701 377.751 277.701 422.991C274.393 385.507 272.53 385.507 237.631 382.921C268.653 380.336 273.991 376.243 277.701 342.852C277.701 382.921 285.456 379.044 317.77 382.921Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.695 314.617C259.117 323.811 254.573 323.071 265.842 336.432C255.528 326.185 254.978 326.649 244.026 334.579C252.544 326.088 253.101 323.55 245.879 312.764C255.861 324.598 257.185 321.521 267.695 314.617Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.733 263.944C313.511 219.793 313.511 148.209 269.733 104.058C225.955 59.9062 154.976 59.9062 111.197 104.058C67.4191 148.209 67.4191 219.793 111.197 263.944C154.976 308.096 225.955 308.096 269.733 263.944Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.147 278.951C179.883 278.954 155.471 269.741 136.415 253.012C117.36 236.283 104.947 213.168 101.468 187.931C97.9882 162.695 103.677 137.041 117.484 115.704C131.292 94.3668 152.286 78.7864 176.592 71.8379C157.301 74.2703 138.969 81.7209 123.397 93.4579C107.824 105.195 95.546 120.815 87.7681 138.784C79.9902 156.753 76.98 176.453 79.0331 195.95C81.0862 215.447 88.1319 234.07 99.4785 249.991C110.825 265.912 126.082 278.582 143.752 286.759C161.421 294.936 180.896 298.337 200.263 296.629C219.63 294.921 238.223 288.162 254.218 277.017C270.212 265.871 283.057 250.722 291.491 233.057C281.886 247.213 269.002 258.792 253.955 266.79C238.909 274.787 222.155 278.962 205.147 278.951Z",
    fill: "#222226"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.908 70.9727C177.664 75.5099 164.664 83.333 153.941 93.8213C143.217 104.31 135.065 117.174 130.132 131.394C125.198 145.614 123.619 160.798 125.519 175.741C127.42 190.684 132.748 204.975 141.08 217.479C149.412 229.983 160.52 240.356 173.521 247.776C186.522 255.195 201.058 259.456 215.977 260.221C230.896 260.985 245.786 258.233 259.466 252.181C273.146 246.129 285.239 236.945 294.785 225.357C301.424 208.332 303.866 189.937 301.902 171.75C299.937 153.563 293.625 136.13 283.507 120.946C273.389 105.762 259.767 93.2818 243.813 84.5774C227.858 75.873 210.047 71.2044 191.908 70.9727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 8.36327,
    y: 0.944328,
    width: 364.203,
    height: 366.114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.815686 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 111.673,
    y1: 263.465,
    x2: 269.955,
    y2: 106.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C88500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunStar);
export default __webpack_public_path__ + "static/media/SunStar.7221779860e26f9e0964b4b5da71704b.svg";
export { ForwardRef as ReactComponent };